import React, { useState } from 'react';
import { useNavigate, generatePath } from 'react-router-dom';
import {
  PageContainerWrapper,
  TablePlus,
  CommonButton,
} from '../../../components';
import useTable from '../../../hooks/useTable.hook';
import {
  Columns,
  getOutstandingPaymentsListService,
} from '../../../services/index.service';
import { accessRoute } from '../../../routes/Reports';
import { useTranslation } from 'react-i18next';

function OutstandingPaymentsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const breadcrumb = Columns.outstandingPaymentsBreadcrumb();

  const [tableHandler, tableProps] = useTable(
    getOutstandingPaymentsListService
  );

  const {
    data,
    isLoading,
    count,
    page,
    noOfPages,
    sizePerPage,
    filter,
    sortBy,
    sortType,
  } = tableProps;

  const { onFilterChange, onTableSort, onFilterResetChange } = tableHandler;

  const [state, setState] = useState({
    selectedRows: [],
  });

  function onRowSelect(e) {
    try {
      setState({ ...state, selectedRows: [...e] });
    } catch (err) {
      console.log('err', err);
    }
  }

  const columns = Columns.outstandingPaymentsTableColumn({
    onSort: onTableSort,
    onFilterChange,
    filter,
    page,
    sizePerPage,
    Action: ({ row }) => (
      <CommonButton
        className="btn btn-primary btn-sm"
        onClick={() => {
          const detailPath = generatePath(
            accessRoute.OUTSTANDING_PAYMENTS_DETAIL.path,
            { customerId: row?.customerId }
          );
          navigate(detailPath);
        }}
      >
        <em className="icon ni ni-eye me-1" />
        {t('text.report.viewDetail')}
      </CommonButton>
    ),
  });

  return (
    <PageContainerWrapper
      heading={t('text.report.outstandingPaymentsHeading')}
      breadcrumb={breadcrumb}
    >
      <TablePlus
        hasLimit
        noOfPage={noOfPages}
        sizePerPage={sizePerPage}
        page={page}
        count={count}
        tableData={data}
        tableColumns={columns}
        tableLoader={isLoading}
        onFilterResetChange={onFilterResetChange}
        filter={filter}
        sortBy={sortBy}
        sortType={sortType}
        handleSelectedRows={onRowSelect}
        statusAction={false}
        showAction={false}
        selectRow={true}
        scrollTopPosition
      />
    </PageContainerWrapper>
  );
}

export default OutstandingPaymentsList;
